export default {
  
  SET_GIFT(state, gifts) {
    state.gifts = gifts
  },
  ADD_GIFT(state, gift) {
    state.gifts.push(Object.assign({}, gift))
  },
  UPDATE_GIFT(state, gift) {
    if(state.gifts.length){
      const roleIndex = state.gifts.findIndex((t) => t.id == gift.id)
      Object.assign(state.gifts[roleIndex], gift)
    }
    else state.gifts = [gift]
  },
  DELETE_GIFT(state, giftId) {
    const index = state.gifts.findIndex(i => i.id == giftId)
    if (index > -1) { state.gifts.splice(index, 1) }
  },

}
